import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './core/vant-use'
import VueRouter from 'vue-router'
import router from './routers'
import '@/plugins'
import '@/configs/config'
import '@/assets/style/base.less'
import { initJsConfig, setConfig } from '@custouch/proxy-use'
import { UAID } from '@/configs/constants'
const { VUE_APP_APP_ID, LOGO } = window.env
setConfig({ appId: VUE_APP_APP_ID, uaId: UAID, logo: LOGO, defaultAccess: { notWechatLimit: 'userinfo', wechatLimit: 'userinfo' }, errorSession: 'site', trackOriginOpenId: true })

initJsConfig(['updateAppMessageShareData',
'updateTimelineShareData',
'hideMenuItems',
'startRecord', // 录音开始api
'stopRecord', // 录音结束api
'onVoiceRecordEnd', // 超过一分钟自动停止api
'playVoice', // 播放录音api
'pauseVoice', // 暂停录音api
'stopVoice', // 停止播放api
'onVoicePlayEnd', // 监听语音播放完毕api
'uploadVoice',
'translateVoice'])

Vue.config.productionTip = false
Vue.use(VueRouter)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
